// extracted by mini-css-extract-plugin
export default {"container":"CL-z","dimension":"DL-z","dimensionLabels":"EL-z"};